import styled from "styled-components";

import { colorsPalettes, setElevation } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import { ExpandablePanelVariant } from "./ExpandablePanel.types";

export const Container = styled(Flex)<{ $variant: ExpandablePanelVariant }>`
    flex-direction: column;
    width: 100%;
    border-radius: 6px;
    background-color: ${colorsPalettes.carbon[0]};
    padding: ${({ $variant }) => ($variant === ExpandablePanelVariant.Nested ? "12px 8px 12px 16px" : "16px")};
    border: ${({ $variant }) =>
        $variant === ExpandablePanelVariant.Nested ? `1px solid ${colorsPalettes.carbon[50]}` : "none"};

    ${({ $variant }) =>
        $variant === ExpandablePanelVariant.Nested &&
        `
        transition: box-shadow 200ms ease;

        &:hover {
            ${setElevation("Z1")}
        }
    `}
`;

export const Header = styled(Flex)<{ $variant: ExpandablePanelVariant; $isOpen: boolean }>`
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    margin-bottom: ${({ $isOpen, $variant }) => {
        if (!$isOpen) {
            return "0";
        }

        return $variant === ExpandablePanelVariant.Nested ? "4px" : "16px";
    }};
    transition: margin-bottom 200ms ease;
    cursor: pointer;
    user-select: none;

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid ${colorsPalettes.blue[400]};
        outline-offset: 2px;
    }
`;

export const ChevronWrap = styled.span<{ $isOpen: boolean }>`
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    transform: ${({ $isOpen }) => ($isOpen ? "rotate(-90deg)" : "rotate(0deg)")};
    transition: transform 200ms ease;
`;

export const ContentWrapper = styled.div<{ $isOpen: boolean }>`
    overflow: hidden;
    display: grid;
    grid-template-rows: ${({ $isOpen }) => ($isOpen ? "1fr" : "0fr")};
    transition: grid-template-rows 200ms ease;
`;

export const ContentInner = styled.div<{ $isOpen: boolean }>`
    min-height: 0;
    overflow: hidden;
    transition: padding 200ms ease;
    padding: 0;
`;
